import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const excelDateToJSDate = (serial) => {
  // Excel serial date → JS Date
  const utc_days = Math.floor(serial - 25569); // 25569 = days from 1900-01-01 to 1970-01-01
  const utc_value = utc_days * 86400;          // seconds
  const date_info = new Date(utc_value * 1000);
  return dayjs(date_info).format("YYYY-MM-DD");
};

const parseDate = (value) => {
  if (!value) return "";

  if (typeof value === "number") {
    // Excel serial number
    return excelDateToJSDate(value);
  }

  // Handle strings in multiple formats (slashes, dashes, dots)
  const formats = [
    // Slash formats
    "D/M/YYYY", "DD/MM/YYYY",
    "D/M/YY", "DD/MM/YY",

    // Dash formats
    "D-M-YYYY", "DD-MM-YYYY",
    "D-M-YY", "DD-MM-YY",
    "YYYY-M-D", "YYYY-MM-DD",

    // Dot formats
    "D.M.YYYY", "DD.MM.YYYY",
    "D.M.YY", "DD.MM.YY",
  ];

  const parsed = dayjs(value, formats, true);

  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

export default parseDate;
